import { schema } from 'normalizr';
import documentSection from './documentSection';

const documentFolderVariantSchema = new schema.Entity('documentFolderVariants', {
  sections: [documentSection],
});

export default documentFolderVariantSchema;
